export default __webpack_public_path__ + "static/media/Amit.63422fbe.png";